import { ref } from 'vue';

const active = ref(false);
const imageSrc = ref('');
const imageMatchStyle = ref('max-width:100%');

/**
 * 전역 이미지 미리보기 (UiModal 호스트에서 표시)
 */
export function openImageModal(src: string, match: string = 'max-width:100%'): void {
  if (typeof window === 'undefined') return;
  imageSrc.value = src;
  imageMatchStyle.value = match;
  active.value = true;
}

export function closeImageModal(): void {
  active.value = false;
}

export function useImageModalState() {
  return { active, imageSrc, imageMatchStyle };
}

if (typeof window !== 'undefined') {
  ;(window as unknown as { openImageModal: typeof openImageModal }).openImageModal = openImageModal;
}
